import React, { useState } from 'react';
import {
  Button,
  TextField,
  Input,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';

import Dialog from '../../ui/Dialog';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay.component';
import { updateCycleDetails } from '../../../services/transaction.service';
import moment from 'moment';

const UpdateCycle = ({ data }) => {
  const { program_id, transaction_code_id, cycle_number, quantity, transaction_date, status } = data;
  const [cycleDetails, setCycleDetails] = useState({
    cycle_number: cycle_number,
    quantity: quantity,
    transaction_date: transaction_date,
  });

  const [state, setState] = useState({
    openConfirmation: false,
    openUpdateCycleConfirmation: true,
    modalTitle: 'Update Cycle',
    errorMessage: null,
    successMessage: 'Cycle has been updated!',
    isLoading: false,
    submitButtonEnabled: false,
  });

  const handleClose = () => {
    const { openConfirmation } = state;
    setState(prev => ({
      ...prev,
      openConfirmation: false,
      openUpdateCycleConfirmation: false,
      errorMessage: null
    }));

    if (openConfirmation) {
      window.location.reload();
    }
  };

  const onUpdateCycle = async () => {
    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const response = await updateCycleDetails({
        program_id,
        transaction_code_id,
        payload: {
          quantity: parseInt(cycleDetails.quantity.toString()),
          cycle_number: cycleDetails.cycle_number,
          transaction_date: cycleDetails.transaction_date,
        },
      });

      setState(prev => ({
        ...prev,
        openUpdateCycleConfirmation: false,
        successMessage: response.message,
      }));
    } catch (e) {
      setState(prev => ({
        ...prev,
        errorMessage: e.message
      }));
    } finally {
      setState(prev => ({ ...prev, isLoading: false, openAddCycleConfirmation: false, openConfirmation: true }));
    }
  };

  const {
    openConfirmation,
    modalTitle,
    errorMessage,
    successMessage,
    isLoading,
    openUpdateCycleConfirmation
  } = state;

  if (isLoading) return <LoadingOverlay />;

  const formButtons = (
    <>
      <Button onClick={handleClose} variant="contained">
        {openConfirmation ? 'OK' : 'Close'}
      </Button>
      {
        openUpdateCycleConfirmation && 
        <Button
          onClick={onUpdateCycle}
          variant="contained"
          color="primary"
          disabled={false}
        >
          Submit
        </Button>
      }
    </>
  );

  const addCycleFormContent = (    
    <>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Cycle Number*</TableCell>
              <TableCell>Quantity*</TableCell>
              <TableCell>Purchase Date*</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <TextField
                  fullWidth
                  value={cycleDetails.cycle_number}
                  onChange={(e) => {
                    const value = e?.target?.value ?? '';
                    setCycleDetails(prev => ({ ...prev, cycle_number: value }));
                  }}
                />
              </TableCell>
              <TableCell>
                <Input
                  type="number"
                  required
                  fullWidth
                  value={cycleDetails.quantity}
                  onChange={(e: any) => {
                    const value = e?.target?.value ?? '';
                    setCycleDetails(prev => ({ ...prev, quantity: value }));
                  }}
                />
              </TableCell>
              {
                status === 'redeemed' && (
                  <TableCell>
                    <TextField
                      type="date"
                      fullWidth
                      value={cycleDetails.transaction_date ? moment(cycleDetails.transaction_date).format('YYYY-MM-DD') : ''}
                      onChange={(e:any) => {
                        const value = e?.target?.value ?? '';
                        setCycleDetails(prev => ({ ...prev, transaction_date: value }));
                      }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </TableCell>
                )
              }
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )

  return (
    <>
      <Dialog
        key="update-cycle"
        open={openUpdateCycleConfirmation}
        title={modalTitle}
        content={addCycleFormContent}
        children={formButtons}
        onSubmit={onUpdateCycle}
        onClose={handleClose}
        titleStyle={{ marginBottom: '10px' }}
      />
      <Dialog 
        onSubmit={handleClose}
        key="confirmation"
        open={openConfirmation}
        title='Update Cycle'
        content={errorMessage || successMessage}
        children={formButtons}
        onClose={handleClose}
      />
    </>
  );
};

export default UpdateCycle;